import React from "react";
import { Form, Formik } from "formik";
import { Checkbox } from "@material-ui/core";
import { useIntl } from "react-intl";
import { IconButton, InputGroup } from "@icecreamsocial/components";
import { RightArrowIcon } from "../SupportedIcons";
import { ChonkyInput } from "../ChonkyInput";
import { PrivacyStatement } from "../PrivacyStatement";

export const CodeUnlocker = ({
  type = "email",
  label = "Your Email Address",
  placeholder = "user@email.com",
  unlockLabel = "Activate Offer",
  termsURL = "https://icecreamsocial.io",
  privacyURL = "https://icecreamsocial.io",
  emailConsentCheckboxId = "emailConsent",
  requireConsent = {},
  buttonId = "influencerSubmit",
  required = true,
  defaultEmail,
  onSubmit,
  ...rest
}) => {
  const intl = useIntl();

  /**
   * Localized strings
   */
  const EMAIL_ERRORS = intl.formatMessage({
    id: "unlock.error.invalidEmail",
    defaultMessage: "Please enter a valid email",
    description: "Error that appears when the user enters an email incorrectly"
  });

  const EMAIL_CONSENT_ERRORS = intl.formatMessage({
    id: "unlock.error.noConsent",
    defaultMessage:
      "Please consent to email communications to participate in this offer",
    description:
      "Error that appears when the user has not consented to email communications"
  });

  const EMAIL_CONSENT_OPT_IN = intl.formatMessage({
    id: "unlock.emailConsentOptIn",
    defaultMessage: "Email me updates",
    description:
      "A label for a checkbox that allows the user to opt in to email updates"
  });

  /**
   * init form
   */
  const formikProps = {
    enableReinitialize: true,
    isInitialValid: true,
    initialValues: {
      email: defaultEmail,
      emailConsent: false
    },
    // need to set these so the button is disabled at the beginning
    initialErrors: {
      email: EMAIL_ERRORS,
      emailConsent: EMAIL_CONSENT_ERRORS
    },
    validate: ({ email = "", emailConsent }) => {
      const errors = {};

      if (!email.trim()) {
        errors.email = EMAIL_ERRORS;
      }

      if (!emailConsent && requireConsent.email) {
        errors.emailConsent = EMAIL_CONSENT_ERRORS;
      }

      return errors;
    },
    onSubmit
  };
  return (
    <Formik {...formikProps}>
      {formik => (
        <Form {...rest}>
          <InputGroup elWidth="100%" marginBottom="md">
            <InputGroup.Label>{label}</InputGroup.Label>
            <InputGroup.Fields paddingLeft="md">
              <ChonkyInput
                type={type}
                name="email"
                onChange={formik.handleChange}
                value={formik.values.email}
                defaultValue={defaultEmail}
                required={required}
              />
            </InputGroup.Fields>
          </InputGroup>
          {requireConsent.email && (
            <>
              {requireConsent.email && (
                <InputGroup elWidth="100%" marginBottom="md">
                  <InputGroup.Fields
                    backgroundColor="none"
                    display="flex"
                    alignItems="center"
                  >
                    <Checkbox
                      id={emailConsentCheckboxId}
                      name="emailConsent"
                      color="primary"
                      value={formik.values.emailConsent}
                      checked={formik.values.emailConsent}
                      onChange={formik.handleChange}
                    />{" "}
                    <InputGroup.Label>{EMAIL_CONSENT_OPT_IN}</InputGroup.Label>
                  </InputGroup.Fields>
                </InputGroup>
              )}
              <PrivacyStatement privacyURL={privacyURL} />
            </>
          )}
          <IconButton
            type="submit"
            iconName="ic_lock_open"
            id={buttonId}
            text={unlockLabel}
            disabled={!formik.isValid}
            backgroundColor="accent"
            textColor="bodyInverse"
            elWidth="100%"
            padding="16px 32px"
            gridColumns="1fr 3fr 1fr"
            data-slate-cta
          >
            <div /> {/* grid layout hax */}
            <IconButton.Text display="block">{unlockLabel}</IconButton.Text>
            <IconButton.Icon as={RightArrowIcon} justifyContent="right" />
          </IconButton>
        </Form>
      )}
    </Formik>
  );
};
